module.exports = __webpack_public_path__ + "img/parking.7d15ccd9.svg";